// extracted by mini-css-extract-plugin
module.exports = {"boardPicker":"abvMm7AH","actions":"ZPBr9CUX","boardFilter":"mVHJ39Nb","selectMark":"G6TUVRci","modalTitle":"dx2ocEVI"};